import ContentLoader from 'react-content-loader';
import { OnlyInMobile, OnlyInPc } from 'src/components/shared/layouts/Responsive';
import styles from 'src/components/shared/products/RankingItem/old.module.scss';

// @refs https://skeletonreact.com/

type Props = {
  id: string;
};
export const ProductDummy: React.FC<Props> = ({ id }) => {
  return (
    <div className={styles.container}>
      <OnlyInPc>
        <ContentLoader
          uniqueKey={id}
          speed={2}
          width={210}
          height={350}
          viewBox="0 0 300 450"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          <rect x="0" y="0" rx="0" ry="0" width="300" height="300" />
          <rect x="0" y="345" rx="2" ry="2" width="300" height="16" />
          <rect x="0" y="310" rx="2" ry="2" width="80" height="23" />
          <rect x="0" y="365" rx="2" ry="2" width="200" height="16" />
          <rect x="0" y="399" rx="2" ry="2" width="80" height="30" />
          <rect x="90" y="412" rx="2" ry="2" width="80" height="16" />
        </ContentLoader>
      </OnlyInPc>
      <OnlyInMobile>
        <ContentLoader
          uniqueKey={id}
          speed={2}
          width={310}
          height={100}
          viewBox="0 0 310 100"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          <rect x="108" y="0" rx="3" ry="3" width="60" height="16" />
          <rect x="108" y="26" rx="3" ry="3" width="200" height="14" />
          <rect x="0" y="0" rx="0" ry="0" width="100" height="100" />
          <rect x="108" y="48" rx="3" ry="3" width="160" height="14" />
          <rect x="108" y="75" rx="3" ry="3" width="60" height="24" />
          <rect x="173" y="82" rx="3" ry="3" width="60" height="16" />
        </ContentLoader>
      </OnlyInMobile>
    </div>
  );
};
